module.exports = __webpack_public_path__ + "media/images/menu/rocks_right-deda6b33544ac3b8b2f671c201c001b6.png";